import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { auth } from "../../../firebase/firebase.utils";
import { connect } from "react-redux";
import { setCurrentAdmin } from "../../../actions/index";
import { writeCachedAdmin } from "../../../utils/cachedAdmin";
//images import
import man from "../../../assets/images/dashboard/user2.jpg";
import "./userMenu.css";
export class User_menu extends Component {
  render() {
    const { currentAdmin } = this.props;
    return (
      <Fragment>
        <li className="onhover-dropdown">
          <div className="media align-items-center">
            {currentAdmin && currentAdmin.imageUrl ? (
              <img
                className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
                style={{
                  maxWidth: "50px",
                  maxHeight: "50px",
                }}
                src={currentAdmin.imageUrl}
                alt="header-user"
              />
            ) : (
              <img
                className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
                src={man}
                alt="header-user"
              />
            )}
            <div className="dotted-animation">
              <span className="animate-circle"></span>
              <span className="main-circle"></span>
            </div>
          </div>
          <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
            <li>
              <Link to={`${process.env.PUBLIC_URL}/settings/profile`}>
                <i data-feather="user"></i>Profile
              </Link>
            </li>

            <li>
              <button
                type="button"
                className="alg-user-menu-action"
                onClick={async () => {
                  auth.signOut().then(() => console.log("user is signed out"));
                  this.props.setCurrentAdmin(null);
                  // Drop the remembered admin too, or the next reload would
                  // optimistically render the shell for someone who signed
                  // out.
                  writeCachedAdmin(null);
                  this.props.history.push("/");
                }}
              >
                <i data-feather="log-out"></i>Logout
              </button>
            </li>
          </ul>
        </li>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
  };
};
export default withRouter(
  connect(mapStateToProps, { setCurrentAdmin })(User_menu)
);
